export default {
  FETCH_UAC_UNIT_EDITION: 'FETCH_UAC_UNIT_EDITION',
  UPDATE_UAC: 'UPDATE_UAC',
  CREATE_UAC: 'CREATE_UAC',
  DELETE_UAC_UNIT: 'DELETE_UAC_UNIT',
  CHOOSE_UAC_SUGGESTION: 'CHOOSE_UAC_SUGGESTION',
  FETCH_UAC_SUCCESS: 'FETCH_UAC_SUCCESS',
  FETCH_UAC_CLIENT_FROM_DOCUMENT: 'FETCH_UAC_CLIENT_FROM_DOCUMENT'
}
